module.exports = __webpack_public_path__ + "img/swipe2.c0b141c4.png";